import { NavBar } from "@components/ui-kit";
import { useStore } from "@src/utils/hooks";
import { computed } from "mobx";
import { observer } from "mobx-react-lite";
import { AppSubNav } from "../AppSubNav";

export const NavigationUsers = observer(function NavigationUsers() {
  const { workspaceStore } = useStore();

  const NAV_ITEMS = computed(() => {
    return workspaceStore.VISIBLE_NAVIGATION.find(
      ({ page }) => page === "users",
    )?.subPages;
  }).get();

  return (
    <AppSubNav>
      {NAV_ITEMS?.map(({ label, url }) => (
        <NavBar.Item key={url} href={url}>
          {label}
        </NavBar.Item>
      ))}
    </AppSubNav>
  );
});
